<c-card *transloco="let t">
    <c-card-body class="px-2">

        <c-row class="justify-content-between">
          <c-col>
            <h1>{{ t('Reports') }}</h1>
          </c-col>
          <c-col class="text-end">
            <a href="https://okalone.zendesk.com/hc/en-gb/articles/35353066501521-App-Location-Settings-Report" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
          </c-col>
        </c-row>
        <c-row>
          <c-col class="col-12">
            <p>{{ t('Please choose one of our reports on this page to learn more about how your workers are using OK Alone. If you need another report, please use the Feature Request button on the main menu.') }}</p>
          </c-col>
        </c-row>

        <c-row>
          <c-col>
            <h3>{{ t('Worker Reports') }}</h3>
            <ol class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Actions Stats') }}</div>
                    {{ t('Graphs showing shift actions') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-stats">{{ t('View') }}</button>
              </li>
              <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Location Settings') }}</div>
                  {{ t('A list of workers and their app location settings') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/location-settings">{{ t('View') }}</button>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('App Not Activated') }}</div>
                  {{ t('These workers have not logged into the app.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-app-not-activated">{{ t('View') }}</button>
              </li>
              <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Group Count') }}</div>
                  {{ t('Shows the number of workers, by group, who have worked a shift in the chosen dates.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-daily-group-count">{{ t('View') }}</button>
              </li>
              @if(okService.isAdmin()){
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{ t('Escalation List') }}</div>
                    {{ t('List of all the workers in your account and their escalation procedures.') }}
                  </div>
                  <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-escalation-list">{{ t('View') }}</button>
                </li>
              }
              @if(okService.isAdmin()){
                <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{ t('Alert Loops') }}</div>
                    {{ t('A list of all the workers in your account and the Alert Loop assigned.') }}
                  </div>
                  <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-alert-loops">{{ t('View') }}</button>
                </li>
              }
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('No Available Location') }}</div>
                  {{ t('These workers are not providing their location on the shift.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-no-location">{{ t('View') }}</button>
              </li>
              @if(okService.hasFeature('mandown')){
              <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Man Down Settings') }}</div>
                  {{ t('A summary of worker man down settings and any changes made that day.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-mandown">{{ t('View') }}</button>
              </li>
              }
              @if(okService.hasFeature('fall_detection')){
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Fall Detection Settings') }}</div>
                  {{ t('A summary of worker fall detection settings and any changes made that day.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-falldetection">{{ t('View') }}</button>
              </li>
              }
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Permissions') }}</div>
                  {{ t('A list of workers and their app permissions.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/permissions">{{ t('View') }}</button>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Last Sync') }}</div>
                  {{ t("Check to see when the worker's mobile app last synced with OK Alone.") }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/last-sync">{{ t('View') }}</button>
              </li>
              @if(okService.hasFeature('app_connectivity')){
              <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Worker Connectivity View') }}</div>
                  {{ t('A list of workers and their app connectivity status') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/app-connectivity">{{ t('View') }}</button>
              </li>
              }
            </ol>
          </c-col>
          <c-col>
            <h3>{{ t('Shift Reports') }}</h3>
            <ol class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Current Status') }}</div>
                  {{ t('View the current status of all the workers') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-status">{{ t('View') }}</button>
              </li>
                <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{ t('Timesheets') }}</div>
                    {{ t("View timesheets for workers' shifts") }}
                  </div>
                  <button class="btn btn-info btn-sm" routerLink="/reports/timesheets">{{ t('View') }}</button>
                </li>
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Has Started A Shift') }}</div>
                  {{ t('These workers have started a shift on chosen dates.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-has-started-shift">{{ t('View') }}</button>
              </li>
              <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Last Shift Started') }}</div>
                  {{ t('A list of workers and the date of their last shift.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-last-shift-started">{{ t('View') }}</button>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('No Shift Started') }}</div>
                  {{ t('These workers have not started a shift within your chosen dates.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-no-shift-started">{{ t('View') }}</button>
              </li>
              <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Short Shifts') }}</div>
                  {{ t('These are workers have shifts that lasted less than 5 minutes.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-short-shift">{{ t('View') }}</button>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Scheduled Start/End Shifts Count') }}</div>
                  {{ t('Get totals of start/end shifts for each worker.') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/start-end-shifts">{{ t('View') }}</button>
              </li>
              @if(okService.isAdmin()){
                <li class="list-group-item bg-light d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{ t('End Worker Shifts') }}</div>
                    {{ t('Filter and end shifts for workers') }}
                  </div>
                  <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/worker-end-shift">{{ t('View') }}</button>
                </li>
              }
            </ol>
          </c-col>
        </c-row>

        <c-row class="mt-4">
          <c-col class="col-md-6 col-12" >
            <h3>{{ t('Monitor Reports') }}</h3>
            <ol class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ t('Monitor Assignment Summary') }}</div>
                  {{ t('A list of monitors with the workers, groups, alert loops and out of hours they are assigned to') }}
                </div>
                <button class="btn btn-info btn-sm" routerLink="/reports/worker-reports/monitor-assignment-summary">{{ t('View') }}</button>
              </li>
            </ol>
          </c-col>
        </c-row>
    </c-card-body>
</c-card>
